// The `extensions.code` values a refused publication settings save comes back with.
export const GraphqlErrorCode = {
  VersionConflict: 'VERSION_CONFLICT',
  SettingsBusy: 'SETTINGS_BUSY',
  SettingsUnavailable: 'SETTINGS_UNAVAILABLE'
} as const;

/**
 * An error the API returned in a GraphQL response, with its `extensions.code`.
 * Not a GraphqlError: callers treat that one as the backend being unreachable.
 */
export class GraphqlResponseError extends Error {
  public readonly code?: string;

  // `name` stays 'Error', so a printed error reads as it did before this class existed.
  public constructor(message: string, code?: string) {
    super(message);
    this.code = code;
  }
}
